// turbo_stream_actions.js
import { get } from "@rails/request.js"
// import { StreamActions } from "@hotwired/turbo-rails"

// Add the ability for the server-side response to drive an turbo stream fetch
Turbo.StreamActions.refetch = function () {
  const url = this.getAttribute("url");
  if (url) {
    get(url, {
      responseKind: "turbo-stream"
    });
  }
}
